import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmojiEmotionsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emoji_emotions"}/>
}
